module.exports = __webpack_public_path__ + "img/04.d0a9f6a0.jpg";